import { prefixObjectValues } from '../utils';

const form = {
  form: 'form',
  certName: 'cert-name-field',
  certNum: 'cert-num-field',
  expiryDate: 'expiry-date-picker',
  issueDate: 'issue-date-picker',
  issuer: 'issuer-comboBox',
  active: 'active-flag',
  removeBtn: 'remove-btn',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(form, 'certs-form');
